{
  "generated": "2026-10-23T20:15:23.762Z",
  "method": "platt",
  "a": 0.8,
  "uiA": 0.25,
  "b": 0,
  "champEdge": 0.38,
  "samples": 2376,
  "runs": 300,
  "testBrierRaw": 0.1923,
  "testBrierCal": 0.1901
}
